import { render, staticRenderFns } from "./equipmentDetail.vue?vue&type=template&id=3c2ac51c&scoped=true&"
import script from "./equipmentDetail.vue?vue&type=script&lang=js&"
export * from "./equipmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./equipmentDetail.vue?vue&type=style&index=0&id=3c2ac51c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2ac51c",
  null
  
)

export default component.exports